<template>
  <div class="choujian-workbench">
    <el-breadcrumb separator="/" style="margin-bottom: 15px">
      <el-breadcrumb-item>运营部</el-breadcrumb-item>
      <el-breadcrumb-item>筹建督导工作台</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 统计区 -->
    <div class="stats-row" ref="statsRow">
      <el-card class="stat-card" shadow="hover">
        <div class="stat-label">总门店数</div>
        <div class="stat-value">{{ statistics.totalCount }}</div>
      </el-card>
      <el-card class="stat-card stat-pending" shadow="hover">
        <div class="stat-label">待接收</div>
        <div class="stat-value">{{ statistics.pendingCount }}</div>
      </el-card>
      <el-card class="stat-card stat-progress" shadow="hover">
        <div class="stat-label">筹建中</div>
        <div class="stat-value">{{ statistics.inProgressCount }}</div>
      </el-card>
      <el-card class="stat-card stat-terminated" shadow="hover">
        <div class="stat-label">已解约</div>
        <div class="stat-value">{{ statistics.terminatedCount }}</div>
      </el-card>
      <el-card class="stat-card stat-done" shadow="hover">
        <div class="stat-label">已完成</div>
        <div class="stat-value">{{ statistics.completedCount }}</div>
      </el-card>
      <el-card class="stat-card stat-transfer" shadow="hover">
        <div class="stat-label">转让待办</div>
        <div class="stat-value">{{ transferStatistics.pendingCount }}/{{ transferStatistics.totalCount }}</div>
      </el-card>
    </div>

    <!-- 搜索区 -->
    <el-card shadow="never" ref="filterCard" :class="{ 'filter-pinned': isPinned }" style="margin-top: 15px">
      <!-- Tab 切换 -->
      <el-tabs v-model="activeTab" @tab-click="onTabClick" style="margin-bottom: 5px">
        <el-tab-pane label="筹建项目" name="choujian"></el-tab-pane>
        <el-tab-pane name="transfer">
          <span slot="label">
            转让项目
            <el-badge v-if="transferStatistics.pendingCount > 0" :value="transferStatistics.pendingCount" type="danger" style="margin-left: 4px;" />
          </span>
        </el-tab-pane>
      </el-tabs>

      <el-form :inline="true" :model="searchForm" size="small">
        <el-form-item label="项目名称">
          <el-input
            v-model="searchForm.keyword"
            placeholder="模糊搜索"
            clearable
            @clear="onSearch"
          />
        </el-form-item>
        <el-form-item label="品牌">
          <el-select v-model="searchForm.signType" placeholder="请选择" clearable style="width: 120px" @change="onSearch">
            <el-option
              v-for="item in brandOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="筹建督导">
          <el-select v-model="searchForm.supervisorId" placeholder="请选择" clearable filterable style="width: 120px" @change="onSearch">
            <el-option
              v-for="item in supervisorOptions"
              :key="item._id"
              :label="item.name"
              :value="item._id"
            />
          </el-select>
        </el-form-item>
        <el-form-item v-if="activeTab === 'choujian'" label="阶段">
          <el-select v-model="searchForm.stage" placeholder="请选择" clearable style="width: 120px" @change="onSearch">
            <el-option
              v-for="item in stageOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item :label="activeTab === 'choujian' ? '接收时间' : '转让时间'">
          <el-date-picker
            v-model="searchForm.dateRange"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            @change="onSearch"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSearch">搜索</el-button>
          <el-button @click="resetSearch">重置</el-button>
        </el-form-item>
      </el-form>

      <!-- 状态筛选 -->
      <div class="status-filter-row">
        <span class="status-filter-label">状态：</span>
        <el-checkbox-group v-model="searchForm.statusList" size="small" @change="onSearch">
          <el-checkbox v-for="item in currentStatusOptions" :key="item.value" :label="item.value">{{ item.label }}</el-checkbox>
        </el-checkbox-group>
      </div>

    </el-card>

    <!-- 列表区 -->
    <el-card shadow="never" ref="listCard" style="margin-top: 15px">
      <!-- 筹建表格 -->
      <el-table
        v-if="activeTab === 'choujian'"
        :data="tableData"
        border
        stripe
        style="width: 100%"
        :height="isPinned ? tableHeight : undefined"
        v-loading="loading"
      >
        <!-- 固定列 -->
        <el-table-column type="index" fixed="left" label="#"/>
        <el-table-column prop="projectName" label="项目名称" fixed="left" min-width="180">
          <template slot-scope="{ row }">
            <span :class="['clickable-name', 'bold', { 'name-unpaid': row.paymentBalance !== null && row.paymentBalance !== undefined && row.paymentBalance > 0 }]" @click="handleProjectClick(row)">{{ row.projectName }}</span>
            <div class="customer-name">客户：{{ row.customerName }}</div>
            <div v-if="row.templateName" class="template-name">{{ row.templateName }}</div>
          </template>
        </el-table-column>
        <el-table-column label="尾款" width="90">
          <template slot-scope="{ row }">
            <el-tag v-if="row.paymentBalance !== null && row.paymentBalance !== undefined && row.paymentBalance > 0" type="danger" size="mini" effect="dark">￥{{ row.paymentBalance }}</el-tag>
            <el-tag v-else-if="row.paymentBalance !== null && row.paymentBalance !== undefined" type="success" size="mini" effect="plain">已付清</el-tag>
            <span v-else class="font12" style="color: #909399">--</span>
          </template>
        </el-table-column>

        <el-table-column prop="supervisorName" label="筹建督导" width="100">
          <template slot-scope="{ row }">
            <span v-if="row.supervisorName && row.supervisorName !== '--'" class="clickable-name" @click="filterBySupervisor(row)">{{ row.supervisorName }}</span>
            <span v-else>--</span>
          </template>
        </el-table-column>

        <el-table-column label="附加信息" min-width="120">
          <template slot-scope="{ row }">
            <el-button type="text" size="small" @click="showAdditionalInfo(row)">查看详情</el-button>
            <span v-if="getRentDisplay(row)" :style="{ fontSize: '11px', marginLeft: '12px', color: getRentDisplay(row).isZero ? '#F56C6C' : '#909399' }">{{ getRentDisplay(row).text }}</span>
          </template>
        </el-table-column>

        <el-table-column label="状态" width="90">
          <template slot-scope="{ row }">
            <el-tag v-if="row.handoverStatus === 1" type="warning" size="mini" effect="dark">待接收</el-tag>
            <el-tag v-else-if="row.handoverStatus === 2" type="primary" size="mini" effect="dark">筹建中</el-tag>
            <el-tag v-else-if="row.handoverStatus === 3 && row.transferOutInfo && row.transferOutInfo.toProjectId" type="warning" size="mini" effect="dark">已转让</el-tag>
            <el-tag v-else-if="row.handoverStatus === 3" type="danger" size="mini" effect="dark">已解约</el-tag>
            <el-tag v-else-if="row.handoverStatus === 4" type="success" size="mini" effect="dark">已完成</el-tag>
          </template>
        </el-table-column>

        <el-table-column label="进度" width="120">
          <template slot-scope="{ row }">
            <el-progress
              v-if="row.progress"
              type="line"
              :percentage="row.progress.percentage"
              :stroke-width="6"
              text-color="#409EFF"
            />
            <span v-else>--</span>
          </template>
        </el-table-column>

        <el-table-column prop="signerName" label="签约人" width="80">
          <template slot-scope="{ row }">
            <span class="font12">{{row.signerName}}</span>
          </template>
        </el-table-column>

        <el-table-column label="移交日期" width="100">
          <template slot-scope="{ row }">
            <span class="font12">{{ row.handoverDate | date }}</span>
          </template>
        </el-table-column>
        <el-table-column label="接收日期" width="100">
          <template slot-scope="{ row }">
            <div class="font12">
              <span v-if="row.handoverStatus === 1" style="color: #909399">未接收</span>
              <span v-else>{{ row.acceptedDate | date }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="筹建天数" width="80">
          <template slot-scope="{ row }">
            <span class="font12">{{ calcChoujianDays(row) }}</span>
          </template>
        </el-table-column>

        <!-- 操作列 -->
        <el-table-column label="操作" fixed="right" width="150">
          <template slot-scope="{ row }">
            <el-button
              v-if="row.handoverStatus === 1"
              type="primary"
              size="mini"
              @click="handleAccept(row)"
            >接收</el-button>
            <template v-else>
              <el-button
                size="mini"
                type="primary"
                plain
                @click="goDetail(row)"
              >详情</el-button>
              <el-button
                v-if="!isTransferProtected(row)"
                type="danger"
                size="mini"
                plain
                :disabled="row.handoverStatus !== 2"
                @click="handleReset(row)"
              >复位</el-button>
            </template>
          </template>
        </el-table-column>
      </el-table>

      <!-- 转让表格 -->
      <el-table
        v-if="activeTab === 'transfer'"
        :data="transferTableData"
        border
        stripe
        style="width: 100%"
        :height="isPinned ? tableHeight : undefined"
        v-loading="loading"
      >
        <el-table-column type="index" fixed="left" label="#"/>
        <el-table-column prop="projectName" label="项目名称" fixed="left" min-width="180">
          <template slot-scope="{ row }">
            <span class="clickable-name bold" @click="goTransferDetail(row)">{{ row.projectName }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="customerName" label="客户" width="120" />
        <el-table-column prop="supervisorName" label="筹建督导" width="100">
          <template slot-scope="{ row }">
            <span class="font12">{{ row.supervisorName || '--' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="signerName" label="签约人" width="80">
          <template slot-scope="{ row }">
            <span class="font12">{{ row.signerName }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="signType" label="品牌" width="80" />

        <!-- 三项节点状态 -->
        <el-table-column label="营业执照" width="110">
          <template slot-scope="{ row }">
            <div class="font12" v-if="row.nodes && row.nodes.BUSINESS_LICENSE">
              <span v-if="row.nodes.BUSINESS_LICENSE.completed">
                <i class="el-icon-circle-check" style="color: #67c23a;"></i>
                {{ row.nodes.BUSINESS_LICENSE.completedAt | date }}
              </span>
              <span v-else style="color: #909399;">
                <i class="el-icon-time"></i> 待处理
              </span>
            </div>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column label="美团订货注册" width="110">
          <template slot-scope="{ row }">
            <div class="font12" v-if="row.nodes && row.nodes.MEITUAN_ORDER_REGISTER">
              <span v-if="row.nodes.MEITUAN_ORDER_REGISTER.completed">
                <i class="el-icon-circle-check" style="color: #67c23a;"></i>
                {{ row.nodes.MEITUAN_ORDER_REGISTER.completedAt | date }}
              </span>
              <span v-else style="color: #909399;">
                <i class="el-icon-time"></i> 待处理
              </span>
            </div>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column label="签订管理协议" width="110">
          <template slot-scope="{ row }">
            <div class="font12" v-if="row.nodes && row.nodes.MANAGEMENT_AGREEMENT">
              <span v-if="row.nodes.MANAGEMENT_AGREEMENT.completed">
                <i class="el-icon-circle-check" style="color: #67c23a;"></i>
                {{ row.nodes.MANAGEMENT_AGREEMENT.completedAt | date }}
              </span>
              <span v-else style="color: #909399;">
                <i class="el-icon-time"></i> 待处理
              </span>
            </div>
            <span v-else>--</span>
          </template>
        </el-table-column>

        <el-table-column label="进度" width="120">
          <template slot-scope="{ row }">
            <el-progress
              v-if="row.progress"
              type="line"
              :percentage="row.progress.percentage"
              :stroke-width="6"
              text-color="#409EFF"
            />
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column label="状态" width="90">
          <template slot-scope="{ row }">
            <el-tag v-if="row.status === 'IN_PROGRESS'" type="warning" size="mini" effect="dark">进行中</el-tag>
            <el-tag v-else-if="row.status === 'COMPLETED'" type="success" size="mini" effect="dark">已完成</el-tag>
            <el-tag v-else size="mini">{{ row.status }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="转让日期" width="100">
          <template slot-scope="{ row }">
            <span class="font12">{{ row.startedAt | date }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" width="100">
          <template slot-scope="{ row }">
            <el-button size="mini" type="primary" plain @click="goTransferDetail(row)">详情</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页（筹建） -->
      <el-pagination
        v-if="activeTab === 'choujian'"
        style="margin-top: 15px; text-align: right"
        @size-change="handleSizeChange"
        @current-change="handlePageChange"
        :current-page="pagination.pagenum"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pagination.pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pagination.total"
      />

      <!-- 分页（转让） -->
      <el-pagination
        v-if="activeTab === 'transfer'"
        style="margin-top: 15px; text-align: right"
        @size-change="handleTransferSizeChange"
        @current-change="handleTransferCurrentChange"
        :current-page="transferPagination.pagenum"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="transferPagination.pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="transferPagination.total"
      />
    </el-card>

    <!-- 接收项目弹框 -->
    <el-dialog title="接收项目" :visible.sync="acceptDialogVisible" width="800px" :close-on-click-modal="false">
      <el-form label-width="100px">
        <el-form-item label="接收项目">
          {{ currentAcceptProject?.projectName }}
        </el-form-item>
        <el-form-item label="流程模板">
          <div class="template-cards">
            <div
              v-for="tpl in templateOptions"
              :key="tpl.code"
              :class="['template-card', { 'template-card--active': selectedTemplateCode === tpl.code }]"
              @click="selectedTemplateCode = tpl.code"
            >
              <div class="template-card__text">
                <div class="template-card__name"><i class="el-icon-document-checked template-card__icon"></i>{{ tpl.name }}</div>
                <div class="template-card__desc">{{ tpl.description }}</div>
              </div>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="出品审核员">
          <el-select v-model="selectedAuditorId" filterable placeholder="请选择">
            <el-option v-for="item in auditorOptions" :key="item._id"
                       :label="item.name" :value="item._id">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="acceptDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="confirmAccept">确认接收</el-button>
      </div>
    </el-dialog>

    <!-- 附加信息弹框（两列：左列键值对附加信息，右列首批物料备忘） -->
    <el-dialog
      title="附加信息"
      :visible.sync="additionalInfoDialogVisible"
      width="840px"
      top="8vh"
      :close-on-click-modal="false"
      @close="additionalInfoEditMode = false"
    >
      <template v-if="currentAdditionalInfoRow">
        <div class="additionalInfoColumns">
          <!-- 左列：键值对附加信息（可编辑字段仅限督导5项白名单） -->
          <div class="additionalInfoCol">
            <div class="additionalInfoColTitle">附加信息</div>
            <el-descriptions :column="1" border size="small">
              <el-descriptions-item
                v-for="(value, key) in currentAdditionalInfoRow.additionalInfo"
                :key="key"
                :label="key"
              >
                <template v-if="additionalInfoEditMode && isEditableField(key)">
                  <el-input v-model="additionalInfoForm[key]" size="small" />
                </template>
                <template v-else>
                  <span v-html="getMultLine(value)"></span>
                </template>
              </el-descriptions-item>
            </el-descriptions>
            <div v-if="!currentAdditionalInfoRow.additionalInfo || Object.keys(currentAdditionalInfoRow.additionalInfo).length === 0" style="color: #909399; text-align: center; padding: 20px;">
              暂无附加信息
            </div>
          </div>

          <!-- 右列：首批物料备忘（列表接口下发字段；只读） -->
          <div class="additionalInfoCol">
            <div class="memoColTitle"><i class="el-icon-warning-outline"></i> 首批物料备忘（招商部提供）</div>
            <template v-if="hasMemo(currentAdditionalInfoRow.firstMaterialMemo)">
              <div class="memoBlockText" v-if="currentAdditionalInfoRow.firstMaterialMemo.text">{{ currentAdditionalInfoRow.firstMaterialMemo.text }}</div>
              <div class="memoBlockImages" v-if="currentAdditionalInfoRow.firstMaterialMemo.images && currentAdditionalInfoRow.firstMaterialMemo.images.length">
                <el-image
                  v-for="(img, idx) in currentAdditionalInfoRow.firstMaterialMemo.images"
                  :key="idx"
                  :src="getMemoImg(img)"
                  :preview-src-list="currentAdditionalInfoRow.firstMaterialMemo.images.map(i => getMemoImg(i))"
                  style="width: 40px; height: 40px; margin-right: 6px; cursor: pointer; border-radius: 4px;"
                  fit="cover">
                </el-image>
              </div>
            </template>
            <div v-else class="memoEmpty">暂无首批物料备忘</div>
          </div>
        </div>
      </template>
      <div slot="footer">
        <template v-if="additionalInfoEditMode">
          <el-button @click="additionalInfoEditMode = false">取消</el-button>
          <el-button type="primary" :loading="additionalInfoSaving" @click="saveAdditionalInfo">保存</el-button>
        </template>
        <template v-else>
          <el-button @click="additionalInfoDialogVisible = false">关闭</el-button>
          <el-button
            v-if="currentAdditionalInfoRow && canEditAdditionalInfo(currentAdditionalInfoRow)"
            type="primary"
            @click="enterAdditionalInfoEdit"
          >编辑</el-button>
        </template>
      </div>
    </el-dialog>
  </div>
</template>

<script>
// 首批物料备忘统一内容判空：兼容 undefined（历史文档）与空对象两种形态
const hasMemo = m => !!((m && m.text && m.text.trim()) || (m && m.images && m.images.length))

export default {
  name: 'ChoujianWorkbench',
  data () {
    return {
      loading: false,
      tableData: [],
      statistics: {
        totalCount: 0,
        pendingCount: 0,
        inProgressCount: 0,
        terminatedCount: 0,
        completedCount: 0
      },
      searchForm: {
        keyword: '',
        signType: '',
        supervisorId: '',
        statusList: [1, 2],
        stage: '',
        dateRange: null
      },
      brandOptions: [
        { label: '美滋滋', value: '美滋滋' },
        { label: '蛮碗香', value: '蛮碗香' },
        { label: '虎头张', value: '虎头张' },
        { label: '长安大东家', value: '长安大东家' }
      ],
      stageOptions: [
        { label: '选址', value: 'site_selection' },
        { label: '首次沟通', value: 'FIRST_COMMUNICATION' },
        { label: '管家注册', value: 'MEITUAN_ORDER_REGISTER' },
        { label: '线上检查', value: 'ONLINE_CHECK' },
        { label: '实操培训', value: 'PRACTICAL_TRAINING_COMPLETE' },
        { label: '账号创建', value: 'ACCOUNT_CREATE' }
      ],
      statusOptions: [
        { label: '待接收', value: 1 },
        { label: '筹建中', value: 2 },
        { label: '已解约', value: 3 },
        { label: '已完成', value: 4 }
      ],
      pagination: {
        pagenum: 1,
        pagesize: 50,
        total: 0
      },
      // 滚动吸顶：统计卡片滚出后，搜索区吸顶 + 表格固定高度
      isPinned: false,
      tableHeight: null,
      scrollContainer: null,
      supervisorOptions: [],
      // 接收弹框相关
      acceptDialogVisible: false,
      currentAcceptProject: null,
      auditorOptions: [],
      selectedAuditorId: '',
      defaultAuditorName: '张文昱',
      templateOptions: [],
      selectedTemplateCode: '',
      // 附加信息弹框相关
      additionalInfoDialogVisible: false,
      currentAdditionalInfoRow: null,
      additionalInfoEditMode: false,
      additionalInfoForm: {
        店铺面积: '',
        店铺电力: '',
        店铺下水: '',
        燃气: ''
      },
      additionalInfoSaving: false,
      // tab 切换
      activeTab: 'choujian',
      // 转让列表
      transferTableData: [],
      transferPagination: { pagenum: 1, pagesize: 50, total: 0 },
      transferStatistics: { totalCount: 0, pendingCount: 0, completedCount: 0 }
    }
  },
  computed: {
    currentEmployeeName () {
      return window.sessionStorage.getItem('employeeName') || ''
    },
    currentStatusOptions () {
      if (this.activeTab === 'transfer') {
        return [
          { value: 'IN_PROGRESS', label: '进行中' },
          { value: 'COMPLETED', label: '已完成' }
        ]
      }
      return this.statusOptions
    }
  },
  created () {
    this.loadData()
    this.loadTransferStats()
    this.loadSupervisorOptions()
  },
  mounted () {
    // 滚动容器为布局的 .content 区（overflow-y:auto），非 window
    this.scrollContainer = this.$el.closest('.content') || window
    this.scrollContainer.addEventListener('scroll', this.handleScroll)
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy () {
    if (this.scrollContainer) {
      this.scrollContainer.removeEventListener('scroll', this.handleScroll)
    }
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    // 滚动监听：统计卡片区底部滚出内容区顶部时，切换吸顶状态
    handleScroll () {
      if (this._scrollTicking) return
      this._scrollTicking = true
      requestAnimationFrame(() => {
        this._scrollTicking = false
        if (!this.$refs.statsRow || !this.scrollContainer) return
        const content = this.scrollContainer
        const contentTop = content === window ? 0 : content.getBoundingClientRect().top
        const statsBottom = this.$refs.statsRow.getBoundingClientRect().bottom
        const shouldPin = statsBottom <= contentTop + 1
        if (shouldPin !== this.isPinned) {
          this.isPinned = shouldPin
          // 吸顶后重算表格高度；解除时清空高度恢复自然展开
          if (shouldPin) {
            this.$nextTick(this.calcTableHeight)
          } else {
            this.tableHeight = null
          }
        }
      })
    },
    handleResize () {
      if (this.isPinned) this.calcTableHeight()
    },
    // 表格固定高度 = 内容区可视高度 - 搜索区高度 - 列表卡片非表格部分（padding/分页/边框）
    // 动态测量非表格部分，避免固定常量偏差导致内容溢出、表头被搜索区遮挡
    calcTableHeight () {
      const content = this.scrollContainer
      if (!content || content === window) return
      const filterEl = this.$refs.filterCard && this.$refs.filterCard.$el
      const filterH = filterEl ? filterEl.offsetHeight : 0
      // 列表区可用高度 = 内容区高度 - 搜索区高度 - 列表卡片 margin-top(15)
      const listAvailable = content.clientHeight - filterH - 15
      // 测量列表卡片中非表格部分（el-card body padding + 分页器 + border）
      const listEl = this.$refs.listCard && this.$refs.listCard.$el
      let nonTableHeight = 110
      if (listEl) {
        const tableEl = listEl.querySelector('.el-table')
        if (tableEl) {
          nonTableHeight = listEl.offsetHeight - tableEl.offsetHeight
        }
      }
      this.tableHeight = Math.max(200, listAvailable - nonTableHeight)
    },
    async loadData () {
      this.loading = true
      try {
        const params = {
          pagenum: this.pagination.pagenum,
          pagesize: this.pagination.pagesize
        }
        if (this.searchForm.keyword) params.keyword = this.searchForm.keyword
        if (this.searchForm.signType) params.signType = this.searchForm.signType
        if (this.searchForm.supervisorId) params.supervisorId = this.searchForm.supervisorId
        if (this.searchForm.statusList && this.searchForm.statusList.length > 0) {
          params.statusList = this.searchForm.statusList.join(',')
        }
        if (this.searchForm.stage) params.stage = this.searchForm.stage
        if (this.searchForm.dateRange && this.searchForm.dateRange.length === 2) {
          params.startDate = this.searchForm.dateRange[0]
          params.endDate = this.searchForm.dateRange[1]
        }

        const { data: res } = await this.$http.get('process/choujian/unifiedList', { params })
        if (res.meta.status !== 200) {
          return this.$message.error(res.meta.msg)
        }
        this.tableData = res.data.list
        this.pagination.total = res.data.total
        this.statistics = res.data.statistics
      } catch (err) {
        this.$message.error('加载数据失败')
      } finally {
        this.loading = false
      }
    },
    async loadSupervisorOptions () {
      try {
        const { data: res } = await this.$http.get('process/getEmployeeList', { params: { role: 'supervisor' } })
        if (res.meta.status === 200) {
          this.supervisorOptions = res.data
        }
      } catch (err) {
        // 忽略错误
      }
    },
    calcChoujianDays (row) {
      if (row.handoverStatus === 1 || row.handoverStatus === 3) {
        return '--'
      }
      if (!row.acceptedDate) return '--'
      const start = new Date(row.acceptedDate)
      let end
      if (row.handoverStatus === 4 && row.completedAt) {
        end = new Date(row.completedAt)
      } else {
        end = new Date()
      }
      const days = Math.ceil((end - start) / (1000 * 60 * 60 * 24))
      return days + '天'
    },
    getMultLine (value) {
      if (value === null || value === undefined || value === '') return '--'
      // 先转义再换行：值来自表单录入，防止 v-html 渲染注入的 HTML
      return String(value)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;')
        .split('\n')
        .join('<br>')
    },
    isEditableField (key) {
      return ['店铺面积', '店铺电力', '店铺下水', '燃气', '房租'].includes(key)
    },
    // 房租显示：值为 '0' 或 0 时用红色提示"无房租信息"，其他值灰色显示，无值不显示
    getRentDisplay (row) {
      const info = row.additionalInfo
      if (!info || info['房租'] === undefined || info['房租'] === null || info['房租'] === '') return null
      const raw = String(info['房租']).trim()
      if (raw === '0' || raw === '0元' || raw === '0.00' || raw === '0.0') {
        return { text: '无房租信息', isZero: true }
      }
      return { text: `房租：${raw}`, isZero: false }
    },
    handleSearch () {
      this.pagination.pagenum = 1
      this.loadData()
    },
    // 统一搜索分发（按 tab）
    onSearch () {
      if (this.activeTab === 'choujian') {
        this.handleSearch()
      } else {
        this.handleTransferSearch()
      }
    },
    resetSearch () {
      if (this.activeTab === 'choujian') {
        this.searchForm = { keyword: '', signType: '', supervisorId: '', statusList: [1, 2], stage: '', dateRange: null }
      } else {
        this.searchForm = { keyword: '', signType: '', supervisorId: '', statusList: ['IN_PROGRESS'], stage: '', dateRange: null }
      }
      this.onSearch()
    },
    handleSizeChange (val) {
      this.pagination.pagesize = val
      this.pagination.pagenum = 1
      this.loadData()
    },
    handlePageChange (val) {
      this.pagination.pagenum = val
      this.loadData()
    },
    async handleAccept (row) {
      this.currentAcceptProject = row

      this.auditorOptions = this.supervisorOptions
      const defaultAuditor = this.supervisorOptions.find(e => e.name === this.defaultAuditorName)
      this.selectedAuditorId = defaultAuditor ? defaultAuditor._id : ''

      const { data: tplRes } = await this.$http.get('process/templates')
      if (tplRes.meta.status === 200) {
        this.templateOptions = (tplRes.data.list || []).filter(t => t.code.includes('BUILD'))
      }
      this.selectedTemplateCode = ''

      this.acceptDialogVisible = true
    },
    async confirmAccept () {
      if (!this.selectedAuditorId) {
        return this.$message.warning('请选择出品审核员')
      }
      if (!this.selectedTemplateCode) {
        return this.$message.warning('请选择流程模板')
      }

      const selectedTemplate = this.templateOptions.find(t => t.code === this.selectedTemplateCode)
      const selectedAuditor = this.auditorOptions.find(e => e._id === this.selectedAuditorId)
      const templateName = selectedTemplate ? selectedTemplate.name : ''
      const auditorName = selectedAuditor ? selectedAuditor.name : ''

      try {
        await this.$confirm(
          `模板：<b>${templateName}</b><br/>审核员：<b>${auditorName}</b>`,
          '确认接收该项目？',
          {
            confirmButtonText: '确认接收',
            cancelButtonText: '取消',
            type: 'warning',
            dangerouslyUseHTMLString: true
          }
        )
      } catch {
        return
      }

      const projectId = this.currentAcceptProject.projectId?._id || this.currentAcceptProject.projectId
      const { data: res } = await this.$http.post(
        `process/handover/accept/${projectId}`,
        {
          auditorId: this.selectedAuditorId,
          auditorName: auditorName,
          templateCode: this.selectedTemplateCode
        }
      )

      if (res.meta.status !== 200) {
        return this.$message.error(res.meta.msg)
      }

      this.$message.success('接收成功')
      this.acceptDialogVisible = false
      this.loadData()
    },
    goDetail (row) {
      this.$router.push(`/dudao/choujian/detail/${row.instanceId || row._id}`)
    },
    handleProjectClick (row) {
      if (row.handoverStatus === 1) {
        this.handleAccept(row)
      } else {
        this.goDetail(row)
      }
    },
    filterBySupervisor (row) {
      const supervisor = this.supervisorOptions.find(s => s.name === row.supervisorName)
      if (supervisor) {
        this.searchForm.supervisorId = supervisor._id
        this.handleSearch()
      }
    },

    // 统一内容判空（模板可用）
    hasMemo,

    // 首批物料备忘截图地址（相对路径拼附件基地址）
    getMemoImg (img) {
      return (window.sessionStorage.getItem('base') || '') + img
    },
    showAdditionalInfo (row) {
      this.currentAdditionalInfoRow = row
      this.additionalInfoEditMode = false
      const info = row.additionalInfo || {}
      this.additionalInfoForm = {
        店铺面积: info['店铺面积'] || '',
        店铺电力: info['店铺电力'] || '',
        店铺下水: info['店铺下水'] || '',
        燃气: info['燃气'] || '',
        房租: info['房租'] || ''
      }
      this.additionalInfoDialogVisible = true
    },
    canEditAdditionalInfo (row) {
      return row.supervisorName === this.currentEmployeeName
    },
    enterAdditionalInfoEdit () {
      const info = this.currentAdditionalInfoRow.additionalInfo || {}
      this.additionalInfoForm = {
        店铺面积: info['店铺面积'] || '',
        店铺电力: info['店铺电力'] || '',
        店铺下水: info['店铺下水'] || '',
        燃气: info['燃气'] || '',
        房租: info['房租'] || ''
      }
      this.additionalInfoEditMode = true
    },
    async saveAdditionalInfo () {
      this.additionalInfoSaving = true
      try {
        const projectId = this.currentAdditionalInfoRow.projectId?._id || this.currentAdditionalInfoRow.projectId
        const { data: res } = await this.$http.put(
          `process/handover/updateAdditionalInfo/${projectId}`,
          this.additionalInfoForm
        )
        if (res.meta.status !== 200) {
          return this.$message.error(res.meta.msg)
        }
        this.$message.success('保存成功')
        this.additionalInfoDialogVisible = false
        this.loadData()
      } catch (err) {
        this.$message.error('保存失败')
      } finally {
        this.additionalInfoSaving = false
      }
    },
    isTransferProtected (row) {
      return !!((row.transferOutInfo && row.transferOutInfo.toProjectId) ||
        (row.transferInInfo && row.transferInInfo.fromProjectId))
    },

    async handleReset (row) {
      try {
        await this.$confirm(
          '确定要将该项目复位到待接收状态吗？复位后将清除所有筹建流程数据，此操作不可撤销。',
          '筹建复位确认',
          {
            confirmButtonText: '确认复位',
            cancelButtonText: '取消',
            type: 'warning'
          }
        )
      } catch {
        return
      }

      const projectId = row.projectId?._id || row.projectId
      const { data: res } = await this.$http.post(`process/handover/reset/${projectId}`)

      if (res.meta.status !== 200) {
        return this.$message.error(res.meta.msg)
      }

      this.$message.success('复位成功')
      this.loadData()
    },

    // ==================== 转让 tab 相关方法 ====================

    // 加载转让统计（轻量接口，初始化时调用）
    async loadTransferStats () {
      try {
        const { data: res } = await this.$http.get('process/transfer/statistics')
        if (res.meta.status === 200) {
          this.transferStatistics = res.data
        }
      } catch (err) {
        // 静默
      }
    },

    // 加载转让列表
    async loadTransferList () {
      this.loading = true
      try {
        const params = {
          pagenum: this.transferPagination.pagenum,
          pagesize: this.transferPagination.pagesize
        }
        if (this.searchForm.keyword) params.keyword = this.searchForm.keyword
        if (this.searchForm.signType) params.signType = this.searchForm.signType
        if (this.searchForm.supervisorId) params.supervisorId = this.searchForm.supervisorId
        if (this.searchForm.statusList && this.searchForm.statusList.length > 0) {
          params.statusList = this.searchForm.statusList.join(',')
        }
        if (this.searchForm.dateRange && this.searchForm.dateRange.length === 2) {
          params.startDate = this.searchForm.dateRange[0]
          params.endDate = this.searchForm.dateRange[1]
        }

        const { data: res } = await this.$http.get('process/transfer/list', { params })
        if (res.meta.status !== 200) {
          return this.$message.error(res.meta.msg)
        }
        this.transferTableData = res.data.list
        this.transferPagination.total = res.data.total
        this.transferStatistics = res.data.statistics
      } catch (err) {
        this.$message.error('加载转让列表失败')
      } finally {
        this.loading = false
      }
    },

    // Tab 点击（Element UI 2.x 的 el-tabs 用 tab-click 事件）
    // v-model 已在事件触发前更新，this.activeTab 是新值
    onTabClick () {
      this.handleTabChange()
    },

    // 统一的 tab 切换处理
    handleTabChange () {
      this.pagination.pagenum = 1
      this.transferPagination.pagenum = 1
      // 重置状态（两套状态值类型不同，不能混用）
      if (this.activeTab === 'choujian') {
        this.searchForm.statusList = [1, 2]
      } else {
        this.searchForm.statusList = ['IN_PROGRESS', 'COMPLETED']
      }
      // 清除阶段（转让无阶段概念）
      if (this.activeTab === 'transfer') this.searchForm.stage = ''
      // 触发对应列表加载
      if (this.activeTab === 'choujian') {
        this.loadData()
      } else {
        this.loadTransferList()
      }
    },

    // 转让列表搜索/翻页
    handleTransferSearch () {
      this.transferPagination.pagenum = 1
      this.loadTransferList()
    },
    handleTransferSizeChange (val) {
      this.transferPagination.pagesize = val
      this.transferPagination.pagenum = 1
      this.loadTransferList()
    },
    handleTransferCurrentChange (val) {
      this.transferPagination.pagenum = val
      this.loadTransferList()
    },

    // 转让详情跳转（复用 ChoujianDetail.vue）
    goTransferDetail (row) {
      this.$router.push(`/dudao/choujian/detail/${row.instanceId}`)
    }
  }
}
</script>

<style scoped>
/* 弹窗两列布局（左键值对/右备忘）与大图预览层级（防被 dialog 遮挡） */
::v-deep .el-image-viewer__wrapper {
  z-index: 3000 !important;
}
.additionalInfoColumns {
  display: flex;
  gap: 20px;
  align-items: stretch;
}
.additionalInfoCol {
  flex: 1;
  min-width: 0;
}
.additionalInfoColTitle {
  font-size: 14px;
  font-weight: bold;
  color: #303133;
  margin-bottom: 10px;
}
.memoColTitle {
  font-size: 14px;
  font-weight: bold;
  color: #B88230;
  margin-bottom: 10px;
}
.memoEmpty {
  color: #909399;
  text-align: center;
  padding: 20px 0;
  font-size: 13px;
}
.memoBlockText {
  font-size: 13px;
  color: #606266;
  line-height: 1.7;
  white-space: pre-wrap;
  word-break: break-all;
  background: #FDF6EC;
  border-left: 3px solid #E6A23C;
  border-radius: 4px;
  padding: 8px 10px;
  max-height: 300px;
  overflow-y: auto;
}
.memoBlockImages {
  margin-top: 8px;
}

/* 滚动吸顶：搜索区固定在内容区顶部，表格在剩余空间内滚动 */
.filter-pinned {
  position: sticky;
  top: 0;
  z-index: 100;
  margin-top: 0 !important;
}
.stats-row {
  display: flex;
  gap: 15px;
}
.stat-card {
  flex: 1;
  text-align: center;
}
.stat-card .stat-label {
  font-size: 13px;
  color: #909399;
  margin-bottom: 8px;
}
.stat-card .stat-value {
  font-size: 32px;
  font-weight: bold;
}
.stat-pending .stat-value { color: #E6A23C; }
.stat-progress .stat-value { color: #409EFF; }
.stat-terminated .stat-value { color: #F56C6C; }
.stat-done .stat-value { color: #67C23A; }
.stat-transfer .stat-value { color: #9C27B0; }
.green{
  color:#67C23A;
}
.blue{
  color:#409EFF;
}
.clickable-name {
  color: #409EFF;
  cursor: pointer;
}
.clickable-name:hover {
  text-decoration: underline;
}
/* 未付清尾款时项目名称红色提醒（需定义在 .clickable-name 之后以覆盖颜色） */
.name-unpaid {
  color: #F56C6C;
}
.bold{
  font-weight: bold;
}
.font12{
  font-size: 12px;
}
.customer-name {
  font-size: 11px;
  color: #606266;
  margin-top: 2px;
}
.template-name {
  font-size: 11px;
  color: #909399;
  margin-top: 2px;
}

/* 模板卡片选择 */
.template-cards {
  display: flex;
  gap: 8px;
}

.template-card {
  flex: 1;
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.2s ease;
  background: #fff;
  min-width: 0;
}

.template-card:hover {
  border-color: #b3d8ff;
}

.template-card--active {
  border-color: #409EFF;
  background: #ecf5ff;
}

.template-card__icon {
  font-size: 14px;
  color: #409EFF;
}

.template-card--active .template-card__icon {
  color: #337ecc;
}

.template-card__text {
  flex: 1;
  min-width: 0;
}

.template-card__name {
  font-size: 13px;
  font-weight: 600;
  color: #303133;
}

.template-card__desc {
  font-size: 12px;
  color: #909399;
  margin-top: 2px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* 状态筛选行 */
.status-filter-row {
  display: flex;
  align-items: center;
  margin-top: 10px;
}
.status-filter-label {
  font-size: 14px;
  color: #606266;
  margin-right: 8px;
}
</style>
